import {Card} from 'platform/components';

import {ReactNode} from 'react';

import i18n from '@dms/i18n';

type VehicleSeriesDefinitionFormDefaultLayoutProps = {
  children?: ReactNode;
};

export const VehicleSeriesDefinitionFormDefaultLayout = ({
  children,
}: VehicleSeriesDefinitionFormDefaultLayoutProps) => (
  <Card title={i18n.t('page.vehicleSeriesDefinition.labels.seriesDefinition')}>{children}</Card>
);
